import React, { Component } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Grid from "@mui/material/Grid";
import { formatReviewStatus } from "../utils/Utils";
import {
  loadSongsBegin,
  addSong,
  saveSongBegin,
  editSongName,
  editUploadStatus,
  removeSong,
  deleteSongBegin,
  BEFORE_SONG_UPLOADED,
  SONG_UPLOADED_LOCALLY,
  SONG_UPLOADED_TO_SERVER,
  saveEvidenceBegin,
  getReviewStatesBegin,
} from "../actions/songactions";
import { connect } from "react-redux";
import { reportError } from "../actions/erroractions";
import PlaySample from "./PlaySample";
import SampleSelection from "./SampleSelection";
import { ACCEPTED_EVIDENCE, EVIDENCE_UPLOADED, REJECT_EVIDENCE, WAITING_FOR_EVIDENCE, evidence_explanation } from "../data/text";
import ReviewInfo from "./ReviewInfo";

class SongList extends Component {
  constructor(props) {
    super(props);
    this.renderSong = this.renderSong.bind(this);
    this.addSong = this.addSong.bind(this);
    this.deleteSong = this.deleteSong.bind(this);
    this.saveSong = this.saveSong.bind(this);
    this.uploadSong = this.uploadSong.bind(this);
    this.renderLoadingSong = this.renderLoadingSong.bind(this);
    this.changeSongLoading = this.changeSongLoading.bind(this);
    this.deleteConfirmation = this.deleteConfirmation.bind(this);
    this.removeSongFromList = this.removeSongFromList.bind(this);
    this.renderPlaySample = this.renderPlaySample.bind(this);
    this.updateReviewStates = this.updateReviewStates.bind(this);
    this.renderRejectionReason = this.renderRejectionReason.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadSongsBegin());
    const period = parseInt(process.env.REACT_APP_REVIEW_UPDATE_PERIOD)
    this.interval = setInterval(this.updateReviewStates, period)
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateReviewStates() {
    const { songs, dispatch } = this.props;

    if (Object.keys(songs).length > 0 && Object.values(songs).some((song, index, array) => song.uploadStatus === SONG_UPLOADED_TO_SERVER)) {
      dispatch(getReviewStatesBegin());
    }
  }

  uploadSong(uniqueName) {
    const { dispatch } = this.props;
    dispatch(editUploadStatus(SONG_UPLOADED_LOCALLY, uniqueName));
  }

  addSong() {
    const { dispatch } = this.props;
    dispatch(addSong());
  }

  editSongName(e, uniqueName) {
    const { dispatch } = this.props;
    dispatch(editSongName(e.target.value, uniqueName));
  }

  deleteConfirmation(uniqueName) {
    const { songs } = this.props;
    if (
      songs[uniqueName].uploadStatus === BEFORE_SONG_UPLOADED ||
      songs[uniqueName].uploadStatus === SONG_UPLOADED_LOCALLY
    ) {
      this.removeSongFromList(uniqueName);
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="form" style={{ left: "30%" }}>
              <Grid container justifyContent="center" alignContent="center">
                <Grid item xs={1} />
                <Grid item xs={10} justifyContent="center">
                  <p>Are sure you want to delete this song?</p>
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={4} />
                <Grid item xs={1}>
                  <button
                    className="bbe-button"
                    onClick={() => {
                      this.deleteSong(uniqueName);
                      onClose();
                    }}
                  >
                    Yes
                  </button>
                </Grid>
                <Grid item xs={2} />
                <Grid item xs={1}>
                  <button className="bbe-button" onClick={onClose}>
                    No
                  </button>
                </Grid>
                <Grid item xs={4} />
              </Grid>
            </div>
          );
        },
      });
    }
  }

  deleteSong(uniqueName) {
    const { dispatch } = this.props;
    dispatch(deleteSongBegin(uniqueName));
  }

  removeSongFromList(uniqueName) {
    const { dispatch } = this.props;
    dispatch(removeSong(uniqueName));
  }

  changeSongLoading(index, isLoading) {
    const songsCopy = this.state.songs.slice();

    songsCopy[index].loading = isLoading;

    this.setState({
      songs: songsCopy,
    });
  }

  saveEvidence(song) {
    const {dispatch} = this.props;

    const pictureData = document.querySelector(
      `input[id="EvidenceUpload${song.uniqueName}"]`
    ).files[0];

    const reviewState = song.reviewStatus;

    const inCorrectState = Boolean(
      reviewState === "WAITING_FOR_EVIDENCE" || reviewState === "PENDING" || reviewState === "IN_REVIEW"
    );

    if (!pictureData) {
      //nothing uploaded
      dispatch(reportError("No evidence uploaded (save song button above)"));
    } else if (!inCorrectState) {
      dispatch(reportError("Evidence already uploaded"));
    } else {
      dispatch(saveEvidenceBegin(pictureData, song.uniqueName));
    }
  }

  saveSong(uniqueName) {
    const { dispatch, songs } = this.props;
    const audioData = document.querySelector(
      `input[id="SongUpload${uniqueName}"]`
    ).files[0];

    const songName = songs[uniqueName].songName;

    const songToUpload = Boolean(
      audioData || songs[uniqueName].uploadStatus !== SONG_UPLOADED_TO_SERVER
    );

    if (!audioData && songToUpload) {
      //nothing uploaded
      dispatch(reportError("No song uploaded"));
    } else if (songToUpload && !audioData.name.match(/.(mp3)$/i)) {
      //not image uploaded
      dispatch(reportError("File should be an MP3 file"));
    } else if (songName === undefined || songName === null || songName === "") {
      //no song name
      dispatch(reportError("Song name is required"));
    } else {
      dispatch(
        saveSongBegin(audioData, songs[uniqueName], songToUpload, uniqueName)
      );
    }
  }

  renderPlaySample(uniqueName) {
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <SampleSelection uniqueName={uniqueName} />
        </Grid>
        <Grid item xs={12}>
          <PlaySample uniqueName={uniqueName}/>
        </Grid>
      </React.Fragment>
    );
  }

  renderSong(song) {
    return (
      <div className="songborder">
        <Grid
          container
          direction="column"
          alignItems="stretch"
          justifyContent="center"
          spacing={3}
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Grid item xs={2} />
            <Grid item xs={8}>
              <input
                type="text"
                className="textbox stretchbox"
                title="Song Name"
                placeholder="Type Song Name"
                onChange={(e) => this.editSongName(e, song.uniqueName)}
                value={song.songName}
              />
            </Grid>
            <Grid item xs={2}>
              <img
                className="icon_button"
                src="https://img.icons8.com/nolan/64/delete-forever.png"
                alt="Delete Song"
                title="Delete Song"
                onClick={() => this.deleteConfirmation(song.uniqueName)}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center" spacing={1}>
            <Grid item xs={2}>
              <label>
                <input
                  id={`SongUpload${song.uniqueName}`}
                  type="File"
                  className="songitem"
                  accept="audio/*"
                  onChange={(e) => this.uploadSong(song.uniqueName)}
                />
                <img
                  className="icon_button"
                  src="https://img.icons8.com/nolan/64/video-file.png"
                  alt="Pick File"
                  title="Pick File"
                />
              </label>
            </Grid>
            <Grid item xs={8}>
              <label>
                {song.uploadStatus}
                {!song.saved && song.uploadStatus === SONG_UPLOADED_TO_SERVER
                  ? "*"
                  : ""}
              </label>
            </Grid>
            <Grid item xs={2}/>
          </Grid>
          {this.renderSaveButton(song.uniqueName)}
          <Grid item xs={12}>
            <hr class="gradient"/>
          </Grid>
          {song.uploadStatus === SONG_UPLOADED_TO_SERVER ? (
            this.renderPlaySample(song.uniqueName)
          ) : (
            <React.Fragment/>
          )}
          
          <Grid item xs={12}>
            <hr class="gradient"/>
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item xs={4}>
                <p>Review Status</p>
              </Grid>
              <Grid item xs={4}>
                <p>{formatReviewStatus(song.reviewStatus)}</p>
              </Grid>
              <Grid item xs={4}>
                {this.renderReviewStatusIcon(song.reviewStatus)}
              </Grid>
            </Grid>
          </Grid>
          {song.uploadStatus === SONG_UPLOADED_TO_SERVER && song.reviewStatus === "REJECTED" ? this.renderRejectionReason(song.reason) : <React.Fragment/>}
          {song.uploadStatus === SONG_UPLOADED_TO_SERVER ? this.renderEvidenceUpload(song) : <div/>}
        </Grid>
        <Grid item xs={12}>
          {song.uploadStatus === SONG_UPLOADED_TO_SERVER ? this.renderEvidenceSaveButton(song) : <div/>}
        </Grid>
      </div>
    );
  }

  renderSaveButton(uniqueName) {
    return <Grid item xs={12}>
            <img
              className="icon_button"
              src="https://img.icons8.com/nolan/64/save.png"
              alt="Save song"
              title="Save Song"
              onClick={() => this.saveSong(uniqueName)}
            />
            <p>
              <small>MP3 file only</small>
            </p>
          </Grid>
  }

  renderEvidenceSaveButton(song) {
    return <img
      className="icon_button"
      src="https://img.icons8.com/nolan/64/save.png"
      alt="Save evidence"
      title="Save evidence"
      onClick={() => this.saveEvidence(song)}
    />
  }

  renderEvidenceUpload(song) {
    return <Grid item xs={12}>
      <hr class="gradient"/>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <label>
              <input
                id={`EvidenceUpload${song.uniqueName}`}
                type="File"
                className="songitem"
                accept="image/png, image/jpeg"
              />
              <img
                className="icon_button"
                src="https://img.icons8.com/nolan/64/video-file.png"
                alt="Pick an Audio file for upload"
                title={evidence_explanation}
              />
            </label>
          </Grid>
          
          <Grid item xs={4}>
            <p title={evidence_explanation}>{this.updateStatusMessage(song.reviewStatus, song.evidenceUploaded)}</p>
          </Grid>
          <ReviewInfo/>
        </Grid>
      </Grid>
  }

  updateStatusMessage(reviewStatus, evidenceUploaded) {

    switch(reviewStatus) {
      case "ACCEPTED":
        return ACCEPTED_EVIDENCE;
      case "REJECTED":
        return REJECT_EVIDENCE;
      case "IN_REVIEW":
        return EVIDENCE_UPLOADED;
      case "PENDING":
        return evidenceUploaded ? EVIDENCE_UPLOADED : WAITING_FOR_EVIDENCE;
      case "WAITING_FOR_EVIDENCE":
      case "UNSEEN":
        return WAITING_FOR_EVIDENCE;
      default:
        return "Unknown state"
    }
  }

  renderRejectionReason(reason) {
    console.log('Reason ' + reason)
    return (
      <React.Fragment>
        <Grid item xs={12}>
            <hr class="gradient"/>
        </Grid>
        <Grid item xs={12}>
          <p>{reason}</p>
        </Grid>
      </React.Fragment>
    )
  }

  renderReviewStatusIcon(reviewStatus) {
    switch(reviewStatus) {
      case "ACCEPTED":
        return <img
        src="https://img.icons8.com/color/48/checked-2--v1.png"
        height="48"
        width="48"
        alt="Approval"/>
      case "REJECTED":
        return <img 
        height="48"
        width="48" 
        src="https://img.icons8.com/fluency/48/cancel.png" alt="cancel"/>
      case "WAITING_FOR_EVIDENCE":
      case "PENDING":
        return <img 
        height="48"
        width="48" 
        src="https://img.icons8.com/ios/50/hourglass-sand-top--v1.png" alt="hourglass-sand-top--v1"/>
      case "IN_REVIEW":
        return <img 
        height="48"
        width="48" 
        src="https://img.icons8.com/pastel-glyph/64/search--v1.png" alt="search--v1"/>
      case "UNSEEN":
        return <img 
        height="48"
        width="48" 
        src="https://img.icons8.com/external-flat-icons-inmotus-design/67/external-empty-mathematics-geometry-flat-icons-inmotus-design.png" alt="external-empty-mathematics-geometry-flat-icons-inmotus-design"/>
      default:
        return <div/>
    }
  }

  renderLoadingSong() {
    return (
      <div className="songborder">
        <ClipLoader color="#FFFFFF" sizeUnit={"%"} size={100} loading={true} />
      </div>
    );
  }

  render() {
    const { songs } = this.props;

    return (
      <div>
        {Object.values(songs)
          .sort((a, b) => a.dateCreated - b.dateCreated)
          .map((song) =>
            song.loading ? this.renderLoadingSong() : this.renderSong(song)
          )}
        <img
          src="https://img.icons8.com/nolan/64/add.png"
          alt="Add Song"
          className="icon_button"
          onClick={this.addSong}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  songs: state.songs.songs,
});

export default connect(mapStateToProps)(SongList);
